import type { ISettingRowProps } from './ISettingRowProps';

/** Рядок налаштування (прототип v4 siStaff/siPolicy): назва 600 і опис 13px приглушено ліворуч, перемикач чи вибір праворуч; лінія знизу. */
export function SettingRow({ title, desc, control }: ISettingRowProps) {
  return (
    <div className="ad-set">
      <span className="ad-set__text"><span className="sp-strong">{title}</span><span className="ad-set__desc">{desc}</span></span>
      {control}
    </div>
  );
}
